var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import { AptiveIcon } from '@aptive-env/storybook';
import { capitalize } from 'lodash';
import Filters from 'components/Filters';
import TableHeader from 'components/TableHeader';
import TableFooter from 'components/TableFooter';
import { PaperClipSVG } from 'icons';
import ChecklistModal from './ChecklistModal';
import DeleteChecklistModal from './DeleteChecklist';
import { fetchChecklistAttachments, fetchChecklists } from 'services/checklist';
import { fetchStates, fetchSeasons } from 'services';
import Direction from 'components/Direction';
import moment from 'moment';
import { formatDate } from 'lib/utils';
import { useToast } from 'hooks/useToast';
import '../../index.scss';
var tHeadClassName = 'flex-1 relative flex items-center gap-2 cursor-pointer text-xs uppercase tracking-[0.03em] px-4 py-3 text-gray-600 hover:text-gray-950 [&_svg]:hover:stroke-[#030712]';
var RequirementsView = function () {
    var setToast = useToast().setToast;
    var _a = useState([]), seasons = _a[0], setSeasons = _a[1];
    var _b = useState([]), states = _b[0], setStates = _b[1];
    var _c = useState([]), checklists = _c[0], setChecklists = _c[1];
    var _d = useState(0), checklistsTotal = _d[0], setChecklistsTotal = _d[1];
    var _e = useState({}), filter = _e[0], setFilter = _e[1];
    var _f = useState(''), search = _f[0], setSearch = _f[1];
    var _g = useState({ name: '', direction: 1 }), sort = _g[0], setSort = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(10), pageSize = _j[0], setPageSize = _j[1];
    var _k = useState(false), isRequirementModalOpen = _k[0], setIsRequirementModalOpen = _k[1];
    var _l = useState(null), selectedChecklist = _l[0], setSelectedChecklist = _l[1];
    var _m = useState([]), selectedChecklistAttachments = _m[0], setSelectedChecklistAttachments = _m[1];
    var _o = useState(false), isDeleteRequirementModalOpen = _o[0], setIsDeleteRequirementModalOpen = _o[1];
    var _p = useState(true), isLoading = _p[0], setIsLoading = _p[1];
    var filterOptions = useMemo(function () {
        return {
            state: { name: 'State', items: states.map(function (state) { return state.name; }), abbr: states.map(function (state) { return state.abbreviation; }) },
            season: { name: 'Season', items: seasons.map(function (season) { return season.name; }) },
            filters: { name: 'Filters' },
            download: { name: 'Download' }
        };
    }, [seasons, states]);
    var selectedState = useMemo(function () { return states.find(function (state) { return state.abbreviation === filter.state; }); }, [filter.state, states]);
    var selectedSeason = useMemo(function () { return seasons.find(function (season) { return season.name === filter.season; }); }, [filter.season, seasons]);
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, fetchChecklists({
                            state_abbr: (_a = selectedState === null || selectedState === void 0 ? void 0 : selectedState.abbreviation) !== null && _a !== void 0 ? _a : undefined,
                            season_id: (_b = selectedSeason === null || selectedSeason === void 0 ? void 0 : selectedSeason.id) !== null && _b !== void 0 ? _b : undefined,
                            search: search || undefined,
                            sortBy: sort.name || undefined,
                            orderBy: sort.name ? (sort.direction === 1 ? 'asc' : 'desc') : undefined,
                            per_page: pageSize,
                            page: currentPage,
                        })];
                case 1:
                    response = _c.sent();
                    setChecklists(response.result.checklists);
                    setChecklistsTotal(response._metadata.pagination.total);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadInitialValues();
    }, []);
    useEffect(function () {
        if (currentPage !== 1)
            setCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedState, selectedSeason, search]);
    useEffect(function () {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize, sort]);
    var loadInitialValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var statesResponse, fetchSeasonsResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchStates()];
                case 1:
                    statesResponse = _a.sent();
                    return [4 /*yield*/, fetchSeasons()];
                case 2:
                    fetchSeasonsResponse = _a.sent();
                    setStates(statesResponse.result.states);
                    setSeasons(fetchSeasonsResponse.result.seasons);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChangeFilter = function (value) {
        setFilter(value);
    };
    var onHandleSort = function (name) {
        setSort({ name: name, direction: sort.name === name ? -sort.direction : 1 });
    };
    var handleDownload = function () {
    };
    var handleAddRequirement = function () {
        setIsRequirementModalOpen(true);
    };
    var handleDeleteChecklist = function (checklist) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSelectedChecklist(checklist);
            setIsDeleteRequirementModalOpen(true);
            return [2 /*return*/];
        });
    }); };
    var handleEditChecklist = function (checklist) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchChecklistAttachments(checklist.id)];
                case 1:
                    response = _a.sent();
                    setSelectedChecklist(checklist);
                    setSelectedChecklistAttachments(response.result.attachments);
                    setIsRequirementModalOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancelRequirementModal = function () {
        setSelectedChecklist(null);
        setSelectedChecklistAttachments([]);
        setIsRequirementModalOpen(false);
    };
    var handleSubmitRequirementModal = function (_a) {
        var success = _a.success, message = _a.message;
        setIsRequirementModalOpen(false);
        setSelectedChecklist(null);
        setSelectedChecklistAttachments([]);
        setToast({
            type: success ? 'success' : 'danger',
            message: message
        });
        loadData();
    };
    var handleHideShowChecklists = function (checklistId, isHidden) {
        var tempChecklists = __spreadArray([], checklists, true);
        for (var _i = 0, tempChecklists_1 = tempChecklists; _i < tempChecklists_1.length; _i++) {
            var checklist = tempChecklists_1[_i];
            if (checklist.id === checklistId) {
                checklist.hidden = isHidden;
            }
        }
        setChecklists(tempChecklists);
    };
    return (_jsxs("div", __assign({ className: "flex flex-col h-0 grow overflow-hidden p-3" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-center h-[70px] px-3" }, { children: [_jsx("h1", __assign({ className: "text-[32px] leading-10" }, { children: "Requirements" })), _jsx(Filters, { options: filterOptions, onChange: function (value) { return onChangeFilter(value); }, onDownload: handleDownload })] })), _jsxs("div", __assign({ className: "flex flex-col flex-1 px-3 pb-3 overflow-hidden" }, { children: [_jsx(TableHeader, { search: search, setSearch: setSearch, addLabel: "Requirements", addNewModalOpen: handleAddRequirement }), _jsxs("div", __assign({ className: "flex flex-col overflow-hidden border-l border-r border-gray-200" }, { children: [_jsxs("div", __assign({ className: "flex flex-none bg-gray-50 border-b border-gray-200" }, { children: [_jsxs("div", __assign({ className: "".concat(tHeadClassName, " ").concat(sort.name === 'state' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('state'); } }, { children: [_jsx("span", { children: "State" }), _jsx(Direction, { sort: sort.name === 'state' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "".concat(tHeadClassName, " ").concat(sort.name === 'county' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('county'); } }, { children: [_jsx("span", { children: "County" }), _jsx(Direction, { sort: sort.name === 'county' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "".concat(tHeadClassName, " ").concat(sort.name === 'municipality' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('municipality'); } }, { children: [_jsx("span", { children: "Municipality" }), _jsx(Direction, { sort: sort.name === 'municipality' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "".concat(tHeadClassName, " ").concat(sort.name === 'created' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('created'); } }, { children: [_jsx("span", { children: "Created" }), _jsx(Direction, { sort: sort.name === 'created' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "".concat(tHeadClassName, " ").concat(sort.name === 'created' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('priority'); } }, { children: [_jsx("span", { children: "Priority" }), _jsx(Direction, { sort: sort.name === 'priority' ? sort.direction : 0 })] })), _jsx("div", __assign({ className: "".concat(tHeadClassName, " justify-center") }, { children: _jsx("span", { children: "Attachment" }) })), _jsx("div", __assign({ className: "flex-1 text-right text-xs text-gray-600 uppercase tracking-[0.03em] p-3" }, { children: "Actions" }))] })), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-y-auto no-scrollbar" }, { children: [isLoading && (_jsx("div", __assign({ className: "flex w-full h-40 items-center justify-center" }, { children: _jsx("span", __assign({ className: "text-lg" }, { children: "Loading data..." })) }))), !isLoading && checklists.length === 0 && (_jsx("div", __assign({ className: "flex w-full h-40 items-center justify-center" }, { children: _jsx("span", __assign({ className: "text-lg" }, { children: "No data" })) }))), !isLoading && checklists.length > 0 && checklists.map(function (checklist) {
                                        var _a, _b, _c;
                                        return (_jsxs("div", __assign({ className: "flex items-center bg-white border-b border-gray-200 cursor-pointer last:border-none ".concat(checklist.hidden ? 'hidden' : '') }, { children: [_jsx("div", __assign({ className: "flex-1 px-4 py-5 text-sm text-gray-600 capitalize" }, { children: (_a = checklist.state) === null || _a === void 0 ? void 0 : _a.name })), _jsx("div", __assign({ className: "flex-1 px-4 py-5 text-sm text-gray-600 capitalize" }, { children: (_b = checklist.county) === null || _b === void 0 ? void 0 : _b.name })), _jsx("div", __assign({ className: "flex-1 px-4 py-5 text-sm text-gray-600 capitalize" }, { children: (_c = checklist.municipality) === null || _c === void 0 ? void 0 : _c.name })), _jsx("div", __assign({ className: "flex-1 px-4 py-5 text-sm text-gray-600" }, { children: moment(checklist.created_at).format(formatDate.FORMAT_DISPLAY) })), _jsxs("div", __assign({ className: "flex items-center gap-3 flex-1 px-4 py-5 text-sm text-[#000000]" }, { children: [checklist.priority === 'low' && _jsx(AptiveIcon, { className: "w-[16px] h-[16px] fill-[#0EA5E9] stroke-none", icon: "chevronDown", isFilled: true }), checklist.priority === 'medium' && _jsx(AptiveIcon, { className: "w-[16px] h-[16px] fill-[#F59E0B] stroke-none", icon: "menuAlt4", isFilled: true }), checklist.priority === 'high' && _jsx(AptiveIcon, { className: "w-[16px] h-[16px] fill-[#F05252] stroke-none", icon: "chevronUp", isFilled: true }), _jsx("span", { children: capitalize(checklist.priority) })] })), _jsxs("div", __assign({ className: "flex items-center justify-center gap-4 flex-1 px-4 py-5 text-sm text-gray-600" }, { children: [_jsx("span", { children: checklist.attachments_count }), _jsx(PaperClipSVG, { className: "[&>path]:hover:stroke-[#1f2937]" })] })), _jsxs("div", __assign({ className: "flex items-center justify-end gap-4 flex-1 px-4 py-5 text-right" }, { children: [_jsx(AptiveIcon, { className: "w-[20px] h-[20px] fill-none stroke-[#9CA3AF] hover:stroke-[#1f2937]", icon: "pencilAlt", onClick: function () { return handleEditChecklist(checklist); } }), _jsx(AptiveIcon, { className: "w-[20px] h-[20px] fill-none stroke-[#9CA3AF] hover:stroke-[#1f2937]", icon: "trash", onClick: function () { return handleDeleteChecklist(checklist); } })] }))] }), checklist.id));
                                    })] }))] })), _jsx(TableFooter, { page: currentPage, setPage: setCurrentPage, pageSize: pageSize, setPageSize: setPageSize, totalResults: checklistsTotal })] })), isRequirementModalOpen && (_jsx(ChecklistModal, { isOpen: isRequirementModalOpen, checklist: selectedChecklist, checklistAttachments: selectedChecklistAttachments, states: states, onCancel: handleCancelRequirementModal, onSubmit: handleSubmitRequirementModal })), _jsx(DeleteChecklistModal, { isOpen: isDeleteRequirementModalOpen, onClose: function () { return setIsDeleteRequirementModalOpen(false); }, onHideShow: handleHideShowChecklists, checklist: selectedChecklist, refresh: loadData })] })));
};
export default RequirementsView;
